/* sm-leit.js - leitargluggi í hausnum (sections/sm-header.liquid).
   Leitartáknið er venjulegur hlekkur á /search. Með JS opnar það glugga með
   tillögum úr Shopify predictive search. ES5, engin söfn. */
(function () {
  'use strict';
  /* Enska (/en): textarnir koma úr JSON-blokk ([data-sld-ord], aðeins utan aðaltungumáls); íslenskan er varagildið, svo íslensk hegðun er óbreytt. */
  var ORD = {};
  try { var oe = document.querySelector('[data-sld-ord]'); if (oe) ORD = JSON.parse(oe.textContent) || {}; } catch (e) { ORD = {}; }
  function tx(k, fb, v) {
    var s = (typeof ORD[k] === 'string' && ORD[k]) ? ORD[k] : fb;
    if (v) { for (var n in v) { if (Object.prototype.hasOwnProperty.call(v, n)) s = s.split('{' + n + '}').join(v[n]); } }
    return s;
  }
  var d = document;
  var gluggi = d.querySelector('[data-sld]');
  if (!gluggi || !window.XMLHttpRequest) return;

  var inntak = gluggi.querySelector('[data-sld-inntak]');
  var listi = gluggi.querySelector('[data-sld-listi]');
  var flokkar = gluggi.querySelector('[data-sld-flokkar]');
  var stada = gluggi.querySelector('[data-sld-stada]');
  var bod = gluggi.querySelector('[data-sld-bod]');
  var loka = gluggi.querySelector('[data-sld-loka]');
  var form = gluggi.querySelector('form');
  var skjol = d.querySelector('[data-sld-skjol]');
  var opnarar = d.querySelectorAll('[data-sld-opna]');
  if (!inntak || !listi || !form) return;

  var slod = gluggi.getAttribute('data-slod') || '/search/suggest';
  var leitSlod = form.getAttribute('action') || '/search';
  var TEGUNDIR = 'product,page,article';
  var SIMI = window.matchMedia ? window.matchMedia('(max-width: 760px)') : null;

  var opid = false;
  var kveikja = null;
  var virkt = -1;
  var kostir = [];
  var bid = null;
  var beidni = null;
  var geymsla = {};
  var sidasta = '';
  var yfirflaedi = '';
  var eigin = Object.prototype.hasOwnProperty;

  function hreinsa(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function kr(v) {
    var n = Math.round(parseFloat(v));
    if (isNaN(n)) return '';
    var s = String(Math.abs(n)), ut = '';
    while (s.length > 3) { ut = '.' + s.slice(-3) + ut; s = s.slice(0, -3); }
    return (n < 0 ? '-' : '') + s + ut + ' kr.';
  }

  function allarSlod(q) {
    return leitSlod + '?q=' + encodeURIComponent(q) + '&type=' + encodeURIComponent(TEGUNDIR) + '&options%5Bprefix%5D=last';
  }

  function myndSlod(u) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=112';
  }

  function erSimi() { return !!(SIMI && SIMI.matches); }

  function stadsetja() {
    var haus = d.querySelector('.nav-outer');
    var efst = 0;
    if (haus && !erSimi()) {
      efst = Math.max(0, Math.round(haus.getBoundingClientRect().bottom));
    }
    gluggi.style.setProperty('--sld-top', efst + 'px');
    if (skjol) skjol.style.setProperty('--sld-top', efst + 'px');
  }

  function setjaStodu(texti) {
    if (stada) stada.textContent = texti;
  }

  function setjaVirkt(i) {
    if (virkt > -1 && kostir[virkt]) kostir[virkt].setAttribute('aria-selected', 'false');
    virkt = i;
    if (i > -1 && kostir[i]) {
      kostir[i].setAttribute('aria-selected', 'true');
      inntak.setAttribute('aria-activedescendant', kostir[i].id);
      if (kostir[i].scrollIntoView) {
        try { kostir[i].scrollIntoView({ block: 'nearest' }); } catch (e) { kostir[i].scrollIntoView(false); }
      }
    } else {
      inntak.removeAttribute('aria-activedescendant');
    }
  }

  function synaFlokka(syna) {
    if (flokkar) flokkar.hidden = !syna;
  }

  function tomur() {
    listi.innerHTML = '';
    listi.hidden = true;
    kostir = [];
    virkt = -1;
    inntak.removeAttribute('aria-activedescendant');
    inntak.setAttribute('aria-expanded', 'false');
    listi.removeAttribute('aria-busy');
    birtaBod('');
    synaFlokka(true);
  }

  function verdTexti(v) {
    var lagt = parseFloat(v.price_min != null ? v.price_min : v.price);
    var hatt = parseFloat(v.price_max != null ? v.price_max : v.price);
    if (isNaN(lagt)) return '';
    return (hatt > lagt ? tx('fra', 'Frá') + ' ' : '') + kr(lagt);
  }

  function teikna(q, gogn) {
    var n = 0;
    var h = [];
    var nidur = (gogn && gogn.resources && gogn.resources.results) || {};
    var vorur = nidur.products || [];
    var soefn = nidur.collections || [];
    var sidur = nidur.pages || [];

    function kostur(href, klasi, innra) {
      var id = 'sld-k-' + (n++);
      if (!/^(\/|https?:\/\/)/.test(String(href || ''))) href = '#';
      return '<a role="option" aria-selected="false" tabindex="-1" id="' + id + '" class="sld-kostur ' + klasi + '" href="' + hreinsa(href) + '">' + innra + '</a>';
    }

    if (vorur.length) {
      h.push('<div role="group" aria-labelledby="sld-h-v"><div class="sld-hopur" id="sld-h-v">' + tx('hopur_vorur', 'Vörur') + '</div>');
      for (var i = 0; i < vorur.length; i++) {
        var v = vorur[i];
        var mynd = (v.featured_image && v.featured_image.url) || v.image || '';
        var verd = verdTexti(v);
        h.push(kostur(v.url, 'sld-vara',
          '<span class="sld-mynd">' + (mynd ? '<img src="' + hreinsa(myndSlod(mynd)) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="sld-texti"><span class="sld-heiti">' + hreinsa(v.title) + '</span>' +
          (verd ? '<span class="sld-verd">' + hreinsa(verd) + '</span>' : '') + '</span>'));
      }
      h.push('</div>');
    }
    if (soefn.length) {
      h.push('<div role="group" aria-labelledby="sld-h-f"><div class="sld-hopur" id="sld-h-f">' + tx('hopur_flokkar', 'Flokkar') + '</div>');
      for (var j = 0; j < soefn.length; j++) {
        h.push(kostur(soefn[j].url, 'sld-rod', '<span class="sld-heiti">' + hreinsa(soefn[j].title) + '</span>'));
      }
      h.push('</div>');
    }
    if (sidur.length) {
      h.push('<div role="group" aria-labelledby="sld-h-s"><div class="sld-hopur" id="sld-h-s">' + tx('hopur_sidur', 'Síður') + '</div>');
      for (var k = 0; k < sidur.length; k++) {
        h.push(kostur(sidur[k].url, 'sld-rod', '<span class="sld-heiti">' + hreinsa(sidur[k].title) + '</span>'));
      }
      h.push('</div>');
    }
    var fjoldi = n;
    h.push('<div role="group" aria-label="' + tx('allar_nidurstodur', 'Allar niðurstöður') + '">' + kostur(allarSlod(q), 'sld-allt',
      '<span class="sld-heiti">' + tx('sja_allt', 'Sjá allar niðurstöður fyrir „{q}“', { q: hreinsa(q) }) + '</span>' +
      '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>') + '</div>');

    listi.innerHTML = h.join('');
    listi.hidden = false;
    birtaBod(fjoldi ? '' : tx('engar_tillogur', 'Engar tillögur fyrir „{q}“. Prófaðu annað orð eða veldu flokk.', { q: q }));
    listi.removeAttribute('aria-busy');
    kostir = listi.querySelectorAll('[role="option"]');
    virkt = -1;
    inntak.removeAttribute('aria-activedescendant');
    inntak.setAttribute('aria-expanded', 'true');
    synaFlokka(!fjoldi);
    setjaStodu(fjoldi ? (fjoldi === 1 ? tx('stada_ein', '1 tillaga og hlekkur á allar niðurstöður. Veldu með örvalyklunum.') : tx('stada_fleiri', '{n} tillögur og hlekkur á allar niðurstöður. Veldu með örvalyklunum.', { n: fjoldi })) : tx('stada_engar', 'Engar tillögur. Ýttu á Enter til að leita.'));
  }

  function birtaBod(texti) {
    if (!bod) return;
    bod.textContent = texti;
    bod.hidden = !texti;
  }

  function villa(q) {
    listi.innerHTML = '';
    listi.hidden = true;
    birtaBod(tx('villa_bod', 'Tillögur náðust ekki. Ýttu á Enter til að leita.'));
    listi.removeAttribute('aria-busy');
    kostir = [];
    virkt = -1;
    inntak.setAttribute('aria-expanded', 'false');
    synaFlokka(false);
    setjaStodu(tx('villa_stada', 'Tillögur náðust ekki.'));
  }

  /* Beiðnin er aftengd áður en hún er stöðvuð, svo onreadystatechange hunsi hana
     og sýni ekki villu þegar glugganum er lokað eða nýtt orð slegið inn. */
  function haetta() {
    var b = beidni;
    beidni = null;
    if (b) b.abort();
  }

  function saekja(q) {
    haetta();
    if (eigin.call(geymsla, q)) { teikna(q, geymsla[q]); return; }
    var x = new XMLHttpRequest();
    beidni = x;
    listi.setAttribute('aria-busy', 'true');
    x.open('GET', slod + '.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection%2Cpage&resources%5Blimit%5D=6' +
      '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Ctag', true);
    x.setRequestHeader('Accept', 'application/json');
    x.onreadystatechange = function () {
      if (x.readyState !== 4 || beidni !== x) return;
      beidni = null;
      var gogn = null;
      if (x.status >= 200 && x.status < 300) {
        try { gogn = JSON.parse(x.responseText); } catch (e) { gogn = null; }
      }
      if (q !== sidasta) return;
      if (!gogn) { villa(q); return; }
      geymsla[q] = gogn;
      teikna(q, gogn);
    };
    x.send();
  }

  function vidInnslatt() {
    var q = inntak.value.replace(/^\s+|\s+$/g, '');
    /* Ny leit: gomlu tillogurnar eiga ekki vid lengur, svo Enter leitar ad nyja ordinu. */
    if (q !== sidasta) { setjaVirkt(-1); kostir = []; }
    sidasta = q;
    if (bid) clearTimeout(bid);
    if (!q) {
      haetta();
      tomur();
      setjaStodu('');
      return;
    }
    bid = setTimeout(function () { bid = null; saekja(q); }, 200);
  }

  function fokusanleg() {
    var allt = gluggi.querySelectorAll('input:not([type="hidden"]), button, a[href]:not([tabindex="-1"])');
    var ut = [];
    for (var i = 0; i < allt.length; i++) {
      var el = allt[i];
      if (el.offsetParent !== null || el === d.activeElement) ut.push(el);
    }
    return ut;
  }

  function setjaOpnara(opinn) {
    for (var i = 0; i < opnarar.length; i++) opnarar[i].setAttribute('aria-expanded', opinn ? 'true' : 'false');
  }

  function opna(fra) {
    if (opid) { inntak.focus(); return; }
    opid = true;
    kveikja = fra || null;
    d.body.classList.remove('header-hidden');
    stadsetja();
    gluggi.hidden = false;
    if (skjol) skjol.hidden = false;
    setjaOpnara(true);
    if (erSimi()) {
      yfirflaedi = d.body.style.overflow;
      d.body.style.overflow = 'hidden';
    }
    inntak.focus();
    if (inntak.value) {
      try { inntak.select(); } catch (e) {}
      vidInnslatt();
    } else {
      tomur();
    }
  }

  function lokaGlugga(skilaFokus) {
    if (!opid) return;
    opid = false;
    if (bid) { clearTimeout(bid); bid = null; }
    haetta();
    listi.removeAttribute('aria-busy');
    gluggi.hidden = true;
    if (skjol) skjol.hidden = true;
    setjaOpnara(false);
    inntak.setAttribute('aria-expanded', 'false');
    d.body.style.overflow = yfirflaedi;
    setjaVirkt(-1);
    if (skilaFokus !== false && kveikja && kveikja.focus) kveikja.focus();
  }

  for (var i = 0; i < opnarar.length; i++) {
    opnarar[i].addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      opna(this);
    });
  }

  inntak.addEventListener('input', vidInnslatt);

  inntak.addEventListener('keydown', function (e) {
    var k = e.key || e.keyCode;
    var n = kostir.length;
    if (k === 'ArrowDown' || k === 'Down' || k === 40) {
      if (!n) return;
      e.preventDefault();
      setjaVirkt(virkt + 1 >= n ? 0 : virkt + 1);
    } else if (k === 'ArrowUp' || k === 'Up' || k === 38) {
      if (!n) return;
      e.preventDefault();
      setjaVirkt(virkt <= 0 ? n - 1 : virkt - 1);
    } else if (k === 'Enter' || k === 13) {
      if (virkt > -1 && kostir[virkt]) {
        e.preventDefault();
        window.location.href = kostir[virkt].href;
      }
    }
  });

  form.addEventListener('submit', function (e) {
    var q = inntak.value.replace(/^\s+|\s+$/g, '');
    if (!q) { e.preventDefault(); inntak.focus(); }
  });

  listi.addEventListener('mousemove', function (e) {
    var t = e.target;
    while (t && t !== listi && t.getAttribute && t.getAttribute('role') !== 'option') t = t.parentNode;
    if (!t || t === listi || !t.getAttribute) return;
    for (var i = 0; i < kostir.length; i++) {
      if (kostir[i] === t) { if (virkt !== i) setjaVirkt(i); return; }
    }
  });

  gluggi.addEventListener('keydown', function (e) {
    var k = e.key || e.keyCode;
    if (k === 'Escape' || k === 'Esc' || k === 27) {
      e.preventDefault();
      e.stopPropagation();
      lokaGlugga(true);
      return;
    }
    if (k === 'Tab' || k === 9) {
      var f = fokusanleg();
      if (!f.length) return;
      var fyrst = f[0], sidast = f[f.length - 1];
      if (e.shiftKey && d.activeElement === fyrst) { e.preventDefault(); sidast.focus(); }
      else if (!e.shiftKey && d.activeElement === sidast) { e.preventDefault(); fyrst.focus(); }
    }
  });

  if (loka) loka.addEventListener('click', function () { lokaGlugga(true); });
  if (skjol) skjol.addEventListener('click', function () { lokaGlugga(true); });

  d.addEventListener('keydown', function (e) {
    var k = e.key || e.keyCode;
    if (opid && (k === 'Escape' || k === 'Esc' || k === 27)) lokaGlugga(true);
  });

  /* Smellt utan gluggans, t.d. á valmyndarhnappinn eða annað í hausnum: loka.
     Skjólið sjálft og leitartáknið sjá um sína smelli. */
  function innanOpnara(t) {
    while (t && t !== d) {
      for (var i = 0; i < opnarar.length; i++) if (opnarar[i] === t) return true;
      t = t.parentNode;
    }
    return false;
  }
  d.addEventListener('mousedown', function (e) {
    var t = e.target;
    if (!opid || !t || gluggi.contains(t) || t === skjol || innanOpnara(t)) return;
    lokaGlugga(false);
  }, true);

  d.addEventListener('focusin', function (e) {
    if (opid && !gluggi.contains(e.target)) inntak.focus();
  });

  window.addEventListener('resize', function () { if (opid) stadsetja(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) lokaGlugga(false); });
})();
